var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "mb14 normal-page",
          attrs: { "body-style": { padding: "20px 20px 20px 20px" } },
        },
        [
          _c("oaFromBox", {
            ref: "oaFromBox",
            attrs: {
              search: _vm.search,
              isViewSearch: false,
              sortSearch: false,
              total: _vm.total,
              title: "合同收支",
              btnText: "导出",
              btnIcon: false,
            },
            on: { addDataFn: _vm.getExportData, confirmData: _vm.confirmData },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "mt10",
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    height: _vm.tableHeight,
                    "row-key": "id",
                    "default-expand-all": "",
                  },
                  on: { "sort-change": _vm.sortChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "date",
                      "min-width": "150",
                      sortable: "",
                      label: "付款时间",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "bill_types",
                      label: "记录类型",
                      "min-width": "90",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                staticClass: "bill-types-tag",
                                attrs: {
                                  type:
                                    scope.row.types === 2
                                      ? "warning"
                                      : "success",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.types === 2 ? "支出" : "收入"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "num",
                      "min-width": "100",
                      label: "付款金额(元)",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pay_type",
                      "min-width": "100",
                      label: "支付方式",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.pay_type !== ""
                                    ? scope.row.pay_type
                                    : "--"
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "client.name",
                      label: "客户名称",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "pointer default-color",
                                on: {
                                  click: function ($event) {
                                    return _vm.clientCheck(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.client
                                        ? scope.row.client.customer_name
                                        : "--"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "contract.contract_name",
                      label: "合同名称",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "pointer default-color",
                                on: {
                                  click: function ($event) {
                                    return _vm.treatyCheck(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.contract
                                        ? scope.row.contract.contract_name
                                        : "--"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status",
                      label: "审核状态",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.status === 1
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass: "status-tag",
                                    attrs: { type: "success" },
                                  },
                                  [_vm._v("已通过")]
                                )
                              : scope.row.status === -1
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass: "status-tag",
                                    attrs: { type: "info" },
                                  },
                                  [_vm._v("已撤回")]
                                )
                              : scope.row.status === 0
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass: "status-tag",
                                    attrs: { type: "warning" },
                                  },
                                  [_vm._v("待审核")]
                                )
                              : _c(
                                  "el-tag",
                                  {
                                    staticClass: "status-tag",
                                    attrs: { type: "danger" },
                                  },
                                  [_vm._v("未通过")]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "业务员", "min-width": "140" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("img", {
                              staticStyle: {
                                width: "24px",
                                height: "24px",
                                "border-radius": "50%",
                                "margin-right": "7px",
                                "vertical-align": "bottom",
                              },
                              attrs: { src: scope.row.card.avatar, alt: "" },
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.card.name) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "created_at",
                      label: "申请时间",
                      "min-width": "140",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "address",
                      fixed: "right",
                      label: _vm.$t("public.operation"),
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCheck(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "footer-expend" }, [
                _c("div", { staticClass: "expend" }, [
                  _c("span", { staticClass: "mr14" }, [
                    _vm._v("累计收款金额(元): "),
                    _c("span", { staticClass: "income" }, [
                      _vm._v(_vm._s(_vm.census.income || "0") + " "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "mr14" }, [
                    _vm._v("累计支出金额(元): "),
                    _c("span", { staticClass: "expend-color" }, [
                      _vm._v(_vm._s(_vm.census.expend || "0") + " "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("\n            审核中金额(元): "),
                    _c("span", { staticClass: "income" }, [
                      _vm._v(
                        _vm._s(_vm.census.review_income || "0") + "（收入）"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "expend-color" }, [
                      _vm._v(
                        _vm._s(_vm.census.review_expend || "0") + "（支出）"
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-fixed" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "page-size": _vm.where.limit,
                      "current-page": _vm.where.page,
                      "page-sizes": [15, 20, 30],
                      layout: "total, sizes,prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.pageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("edit-customer", {
        ref: "editCustomer",
        attrs: { "form-data": _vm.clientFromData },
      }),
      _vm._v(" "),
      _c("edit-contract", {
        ref: "editContract",
        attrs: { "form-data": _vm.contractFromData },
      }),
      _vm._v(" "),
      _c("detail-examine", {
        ref: "detailExamine",
        on: { getList: _vm.getTableData },
      }),
      _vm._v(" "),
      _c("export-excel", {
        ref: "exportExcel",
        attrs: {
          template: false,
          "save-name": _vm.saveName,
          "export-data": _vm.exportData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }